﻿import { ValidateResult } from "../../validation/validateResult";
import { MandatoryDataMissing } from "../../validation/validationConstants";
import { ValidationMessage } from "../../validation/validationMessage";
import { ValidationMessageType } from "../../validation/validationMessageType";
import { IValidator, ValidatorTuple  } from "../../validation/validators/iValidator";


export class EmployeeIdValidator implements IValidator {
    public validate(value: any, propertyName: string, propertydisplayName: string, errorMessage: string, param: any): ValidateResult {
        let user = param.user;
        let result = new ValidateResult();

        if(user.department.id=="37226815"){
                let prop = propertyName === "last4SSN" ? "employeeId" : "last4SSN";
                let msgsToRemove = param.validationMessages.filter((msg) => msg.propertyName === prop &&
                        msg.message == "Last 4 of SSN or Employee Id is required");
                    for (let index = 0; index < msgsToRemove.length; index++) {
                        param.removeValidationMessage(msgsToRemove[index]);
                    }
                    return;
        }

        if (user && !user.last4SSN && !user.employeeId && !user.IsPrivateAttorney) {
            let vm = new ValidationMessage();
            vm.message = "Last 4 of SSN or Employee Id is required";
            vm.propertyName = propertyName;
            vm.messageType = ValidationMessageType.Error;
            result.validationMessage = vm;
        } else {
            if (user && user[propertyName]) {
                let prop = propertyName === "last4SSN" ? "employeeId" : "last4SSN";
                if (propertyName === "last4SSN" && user.last4SSN.length !== 4) {
                    let vm = new ValidationMessage();
                    vm.message = "The Last4SSN must be at least 4 characters long.";
                    vm.propertyName = propertyName;
                    vm.messageType = ValidationMessageType.Error;
                    result.validationMessage = vm;
                    result.isValid = true;
                }
                if (propertyName === "employeeId" && user.employeeId.length < 6) {
                    let vm = new ValidationMessage();
                    vm.message = "Employee Id should be minimum 6 numbers";
                    vm.propertyName = propertyName;
                    vm.messageType = ValidationMessageType.Error;
                    result.validationMessage = vm;
                    result.isValid = true;
                }
                else {
                    let msgsToRemove = param.validationMessages.filter((msg) => msg.propertyName === prop &&
                        msg.message == "Last 4 of SSN or Employee Id is required");
                    for (let index = 0; index < msgsToRemove.length; index++) {
                        param.removeValidationMessage(msgsToRemove[index]);
                    }
                }
            }

        }
        return result;
    }
}

